import { render, staticRenderFns } from "./setWithhold.vue?vue&type=template&id=d2de4990&"
import script from "./setWithhold.vue?vue&type=script&lang=js&"
export * from "./setWithhold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2de4990')) {
      api.createRecord('d2de4990', component.options)
    } else {
      api.reload('d2de4990', component.options)
    }
    module.hot.accept("./setWithhold.vue?vue&type=template&id=d2de4990&", function () {
      api.rerender('d2de4990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setWithhold.vue"
export default component.exports